import type { RendererProps } from './type';

import { VERSION_OPTIONS } from '~/modules/report-analytic';
import { GVariantBadge } from '~/presentation/ui';
import { WrapperCell } from './WrapperCell';

export const VersionCell = ({
  value,
  previousValue,
  isMergedWithPrev,
  columnLayout,
}: RendererProps) => {
  const variantValue = VERSION_OPTIONS.find((opt) => opt.label.split(' ')[1] === value);

  if (isMergedWithPrev) return '';

  return (
    <WrapperCell
      previousValue={previousValue}
      isMergedWithPrev={isMergedWithPrev}
      columnLayout={columnLayout}
    >
      {variantValue && (
        <GVariantBadge
          variant={variantValue.value}
          tone={variantValue.value === 'A' ? 'active' : 'inactive'}
          size="xs"
        />
      )}
    </WrapperCell>
  );
};
